{
  "messages": {
    "networkError": "Ocurrió un error de red. Si el problema persiste, contáctanos.",
    "appointmentUpdatedValidationFailed": "La cita fue actualizada, pero falló la validación externa.",
    "appointmentCreatedValidationFailed": "La cita fue creada, pero falló la validación externa.",
    "validationErrorDetail": "<br /> Error de validación: {error}"
  },
  "titles": {
    "warehouseRuleFailed": "Falló la regla del almacén",
    "validationServerError": "Error del servidor de validación",
    "appointmentUpdatedWithValidationError": "Cita actualizada con error de validación",
    "appointmentCreatedWithValidationError": "Cita creada con error de validación"
  }
}
